import React from "react";
import PortalModal from "../../Portals";
import {
  CloseModal,
  ContentModal,
  PrincipalTitle,
  TextModal,
} from "./ModalRequestsSOS.styled";
import Tooltip from "@material-ui/core/Tooltip";
import { IconButton } from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import MaterialTable from "material-table";
import { theme as themeConfig } from "../../themes/themes";

const ModalRequestsSOS = ({
  setShowRequestsSOS,
  handleRow,
  selectedRow,
  listOfRequests,
  title,
  columnData,
}) => {
  return (
    <PortalModal>
      <ContentModal>
        <CloseModal>
          <Tooltip title="close">
            <IconButton onClick={() => setShowRequestsSOS(false)}>
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </CloseModal>
        <TextModal>
          <PrincipalTitle>{title}</PrincipalTitle>
            <MaterialTable
              title=""
              columns={columnData}
              data={listOfRequests}
              onRowClick={(evt, rowSelected) => handleRow(rowSelected)}
              options={{
                headerStyle: {
                  fontWeight: "bold",
                  backgroundColor: themeConfig.neutral.gray[800],
                },
                rowStyle: (rowData) => ({
                  backgroundColor:
                    selectedRow === rowData.tableData.id ? "#F7EAF7" : "#FFF",
                }),
                search: false,
              }}
            />
        </TextModal>
      </ContentModal>
    </PortalModal>
  );
};

export default ModalRequestsSOS;
